import React from 'react'
import '../styles/Servicios/SupliersServices.css'
//Images-Icons
import mainIcons from '../assets/imagenes/icons_home.png'
import mainIconsMobile from '../assets/imagenes/ProvedoresMobile.png'
import estadisticas from '../assets/iconos/estadisticas.png'
import mercado from '../assets/iconos/mercado.png'
import documento from '../assets/iconos/documentos.png'
import seguro from '../assets/iconos/seguro.png'
import financiacion from '../assets/iconos/finanzas.png'

import { useTranslation } from 'react-i18next'

function SupliersServices() {
  const {t} = useTranslation();

  return (
    <section>
      <div className='suppliers-row'>
        <div className='mainIcon-container'>
          <img src={mainIcons} alt="mainIcons" className='mainIcons'/>
          <img src={mainIconsMobile} alt="mainIcons" className='mainIconsMobile'/>
        </div>
        <div className='suppliers-text'>
          <div className='subtitle'>
            <h3>{t("supplier_1")}</h3>
          </div>
          <div className='suppliers-first-services'>
            <h4>{t("supplier_2")}</h4>
            <p>{t("supplier_3")}</p>
            <h4>{t("supplier_4")}</h4>
            <p>{t("supplier_5")}</p>
          </div>
        </div>
      </div>
      
      <div className='subtitle-pad'>
        {t("supplier_6")}
      </div>
      <div className='suppliers-second-services'>
        <div className='services-container-first'>
          <img src={mercado} alt="suppliersIcons" className='suppliersIcons'/>
          <br />
          <h4>{t("supplier_7")}</h4>
          <p>
          {t("supplier_8")}
          </p>
        </div>
        <div className='services-container-second'>
          <img src={documento} alt="suppliersIcons" className='suppliersIcons'/>
          <br />
          <h4>{t("supplier_9")}</h4>
          <p>
          {t("supplier_10")}
          </p>
        </div>
        <div className='services-container-first'>
          <img src={estadisticas} alt="suppliersIcons" className='suppliersIcons'/>
          <br />
          <h4>{t("supplier_11")}</h4>
          <p>
          {t("supplier_12")}
          </p>
        </div>
      </div>
    </section>
  )
}

export default SupliersServices